import { debounce } from '@/utils/api';
import store from '@/store';
import { RESIZE_DEBOUNCE_TIME } from '@/utils/const';

const docEle = document.documentElement;
// 基准大小
const baseSize = 100;

let scrollbarWidth;

const getScrollbarWidth = () => {
	//初始化第一次判断是否存在滚动条
	if (docEle.scrollHeight <= docEle.clientHeight) return 0;

	if (scrollbarWidth) return scrollbarWidth;

	// 创建一个临时的div元素
	let outer = document.createElement('div');
	outer.style.visibility = 'hidden'; // 使其不可见
	outer.style.overflow = 'scroll'; // 使其包含滚动条
	document.body.appendChild(outer);

	// 获取滚动条的宽度
	scrollbarWidth = outer.offsetWidth - outer.clientWidth;
	// 移除临时的div元素
	document.body.removeChild(outer);

	return scrollbarWidth;
};

// 设置 rem 函数
const setRem = () => {
	const SWITCH_THRESHOLD = 760;
	const DESIGN_WIDTH_PC = 1440;
	const DESIGN_WIDTH_MOBILE = 375;

	// 获取屏幕可用宽度
	const screenWidth = screen.availWidth;

	// 适配宽度比例
	const scrollbarW = getScrollbarWidth();
	let adjustedWidth;
	if (screenWidth.width / screenWidth.height > 16 / 9) {
		adjustedWidth = (screenWidth.height / 9) * 16;
	} else {
		adjustedWidth = screenWidth;
	}
	adjustedWidth += scrollbarW;

	// 获取视口宽度
	const viewportWidth = docEle.clientWidth;

	// mobile: 760px
	const isPC = viewportWidth > SWITCH_THRESHOLD;
	const isMobile = !isPC;

	// 更新 store 中的视图模式状态
	store.commit('SET_IS_MOBILE', isMobile);

	// 动态设置font-size
	if (adjustedWidth < DESIGN_WIDTH_PC && adjustedWidth > SWITCH_THRESHOLD) {
		docEle.style.fontSize = isPC
			? `${baseSize * (adjustedWidth / DESIGN_WIDTH_PC)}px`
			: `${baseSize * (viewportWidth / DESIGN_WIDTH_MOBILE)}px`;
	} else {
		docEle.style.fontSize = isPC ? `${baseSize}px` : `${baseSize * (viewportWidth / DESIGN_WIDTH_MOBILE)}px`;
	}
};

// 改变窗口大小时重新设置 rem
const onResizeRem = debounce(setRem, RESIZE_DEBOUNCE_TIME);
window.addEventListener('resize', onResizeRem, RESIZE_DEBOUNCE_TIME);
// 初始化
setRem();
